/* Mosquito Beads — variant picker styling (FINAL).
   Lives in your Horizon theme as Assets/mb-variant-picker.js,
   loaded from theme.liquid. This is the saved reference copy. */
(function () {
  function isSel(l) {
    var inp = l.querySelector('input') || l.previousElementSibling;
    if (inp && inp.tagName === 'INPUT') return inp.checked;
    if (l.getAttribute('aria-checked') === 'true' || l.getAttribute('aria-pressed') === 'true') return true;
    return /selected|active|checked/i.test(l.className);
  }
  function decorate() {
    var labels = document.querySelectorAll('fieldset label, [class*="variant"] label, .product-form label, variant-picker label');
    labels.forEach(function (l) {
      var t = (l.textContent || '').trim();
      var key = /sidekick/i.test(t) ? 'side' : (/signature/i.test(t) ? 'sig' : null);
      if (!key) return;
      l.style.position = 'relative'; l.style.overflow = 'visible';
      l.style.setProperty('display', 'flex', 'important');
      l.style.setProperty('flex-direction', 'column', 'important');
      l.style.setProperty('align-items', 'flex-start', 'important');
      l.style.setProperty('justify-content', 'center', 'important');
      l.style.setProperty('text-align', 'left', 'important');
      l.style.setProperty('gap', '2px', 'important');
      l.style.setProperty('padding', '16px 16px', 'important');
      l.style.setProperty('min-height', '64px', 'important');
      l.style.setProperty('border-radius', '16px', 'important');
      if (isSel(l)) {
        l.style.setProperty('background', '#d4e9f5', 'important');
        l.style.setProperty('border', '2px solid #356f93', 'important');
      } else {
        l.style.setProperty('background', '#ffffff', 'important');
        l.style.setProperty('border', '2px solid #cfe2ee', 'important');
      }
      Array.prototype.forEach.call(l.children, function (c) {
        if (c.tagName === 'INPUT') return;
        if (c.className && String(c.className).indexOf('mb-') > -1) return;
        c.style.setProperty('display', 'none', 'important');
      });
      Array.prototype.forEach.call(l.childNodes, function (n) { if (n.nodeType === 3) n.textContent = ''; });
      if (!l.querySelector('.mb-name')) {
        var name = document.createElement('span'); name.className = 'mb-name';
        name.textContent = key === 'sig' ? 'The Signature' : 'The Sidekick';
        name.style.cssText = "display:block;font-family:'scandia-web',sans-serif;font-weight:700;font-size:20px;color:#4a2e22;line-height:1.15;text-align:left;";
        var sub = document.createElement('span'); sub.className = 'mb-sub';
        sub.textContent = key === 'sig' ? '18 oz · Up to 1,000 sq ft' : '5 oz · Up to 300 sq ft';
        sub.style.cssText = "display:block;font-family:'scandia-web',sans-serif;font-weight:500;font-size:12px;color:#5e7c8c;margin-top:4px;line-height:1.2;text-align:left;";
        var price = document.createElement('span'); price.className = 'mb-price';
        price.textContent = key === 'sig' ? '$34.99' : '$18.99';
        price.style.cssText = "display:block;font-family:'scandia-web',sans-serif;font-weight:700;font-size:15px;color:#4a2e22;margin-top:6px;line-height:1.2;text-align:left;";
        l.appendChild(name); l.appendChild(sub); l.appendChild(price);
      }
      if (key === 'sig' && !l.querySelector('.mb-bs')) {
        var b = document.createElement('span'); b.className = 'mb-bs'; b.textContent = 'Bestseller';
        b.style.cssText = "position:absolute;top:-9px;right:8px;z-index:5;background:#a64f2d;color:#fff;font-family:'scandia-web',sans-serif;font-weight:700;font-size:10px;letter-spacing:.05em;text-transform:uppercase;padding:4px 8px;border-radius:20px;pointer-events:none;";
        l.appendChild(b);
      }
    });
  }
  function init() {
    decorate();
    document.addEventListener('change', decorate, true);
    document.addEventListener('click', function () { setTimeout(decorate, 60); }, true);
    if (window.MutationObserver) { new MutationObserver(decorate).observe(document.body, { subtree: true, childList: true }); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
